import {
  keepPreviousData,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import {
  retrieveAttorneySummary,
  updateAttorneyReportDefaultRole,
  type AttorneySummaryFilters,
} from "@/lib/data/requests/reports/reports-attorney-summary";
import { queryKeys } from "@/lib/data/static";
import type { APIError } from "@/lib/types";
import { toastAPIErrorMessage } from "@/lib/utils/axiosUtils";
import type { AxiosError } from "axios";
import toast from "react-hot-toast";

export const attorneySummaryQueryOptions = (
  filters: AttorneySummaryFilters,
) => ({
  queryKey: [queryKeys.reports, "attorney-summary", filters],
  queryFn: ({ signal }: { signal: AbortSignal }) =>
    retrieveAttorneySummary(filters, signal),
  placeholderData: keepPreviousData,
  refetchInterval: 30_000,
});

export function useUpdateAttorneyReportDefaultRole() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateAttorneyReportDefaultRole,
    onSuccess: (response) => {
      toast.success(
        response.data.pinnedRoleId
          ? "Default role pinned for everyone"
          : "Default role unpinned",
      );
    },
    onError: (error: AxiosError<APIError>) => {
      toastAPIErrorMessage(error, "The default role could not be saved");
    },
    onSettled: async () => {
      await queryClient.cancelQueries({
        queryKey: [queryKeys.reports, "attorney-summary"],
      });
      await queryClient.invalidateQueries({
        queryKey: [queryKeys.reports, "attorney-summary"],
      });
    },
  });
}
